<po-page-default p-title="Regras de Classificação Automática">

  <po-tabs>
    <po-tab p-label="CT-e" [p-active]="abaAtiva === 'cte'" (p-click)="ativar('cte')">
      <app-regras-cte *ngIf="montada('cte')"></app-regras-cte>
    </po-tab>

    <po-tab p-label="NFS-e" [p-active]="abaAtiva === 'nfse'" (p-click)="ativar('nfse')">
      <app-regras-nfse *ngIf="montada('nfse')"></app-regras-nfse>
    </po-tab>

    <po-tab p-label="Natureza Financeira" [p-active]="abaAtiva === 'natureza'" (p-click)="ativar('natureza')">
      <app-regras-natureza *ngIf="montada('natureza')"></app-regras-natureza>
    </po-tab>

    <po-tab p-label="De-para de Serviço" [p-active]="abaAtiva === 'produto'" (p-click)="ativar('produto')">
      <app-regras-produto *ngIf="montada('produto')"></app-regras-produto>
    </po-tab>

    <po-tab p-label="Tomadores" [p-active]="abaAtiva === 'tomador'" (p-click)="ativar('tomador')">
      <app-regras-tomador *ngIf="montada('tomador')"></app-regras-tomador>
    </po-tab>

    <po-tab p-label="Simulador" [p-active]="abaAtiva === 'simulador'" (p-click)="ativar('simulador')">
      <app-regras-simulador
        *ngIf="montada('simulador')"
        (abrirRegra)="irParaRegra($event)">
      </app-regras-simulador>
    </po-tab>
  </po-tabs>

</po-page-default>
